import React from 'react';

export default function Spinner({ cover }) {
  const spinnerSize = 48;
  const spinnerThickness = 4;
  const spinnerColor = "#3273dc";
  const spinnerBg = "#dbdbdb";

  const spinnerStyle = {
    width: spinnerSize,
    height: spinnerSize,
    border: `${spinnerThickness}px solid ${spinnerBg}`,
    borderTop: `${spinnerThickness}px solid ${spinnerColor}`,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    background: "transparent",
    display: "inline-block",
  };

  // Keyframes for animation (inject once)
  React.useEffect(() => {
    const styleId = "spinner-keyframes";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.innerHTML = `
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  const spinner = <div style={spinnerStyle} />;

  if (cover) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(150,150,150,0.7)",
          zIndex: 1300,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {spinner}
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "4rem"
      }}
    >
      {spinner}
    </div>
  );
}
